/** @jsx jsx */
import { jsx } from "theme-ui"
import EventDetail from "../event-detail"

const EventDetailPattern = ({ blade, ...restProps }) => {
  return <EventDetail sx={{ width: "100%" }} />
}

export default EventDetailPattern
